import { render, staticRenderFns } from "./BillReceivebleDetails.vue?vue&type=template&id=7b0afcac"
import script from "./BillReceivebleDetails.vue?vue&type=script&lang=js"
export * from "./BillReceivebleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports